import { API_CONFIG } from '@/config/apiConfig';
import { apiClient } from './client';
import { getDisplayValue } from './displayValue';
import { normalizeFieldValue } from './valueNormalizer';

const isEmptySubmissionValue = (value) => {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim() === '';
  }

  return false;
};

const buildFieldsPayloadWithoutEmptyValues = (fieldConfigs, fieldValues) => {
  return (fieldConfigs || []).reduce((fields, fieldConfig) => {
    const rawValue = fieldValues?.[fieldConfig.name] ?? null;
    const typeName = (fieldConfig.type || fieldConfig.TypeName || '').toLowerCase();
    const normalizedValue = normalizeFieldValue(fieldConfig, rawValue);

    if (isEmptySubmissionValue(normalizedValue)) {
      return fields;
    }

    const displaySourceValue = typeName === 'boolean' ? rawValue : normalizedValue;
    const displayValue = getDisplayValue(fieldConfig, displaySourceValue);

    fields.push({
      Code: fieldConfig.name,
      Value: normalizedValue,
      Label: fieldConfig.label,
      DisplayValue: displayValue,
      Section: fieldConfig.section,
    });

    return fields;
  }, []);
};

const buildDataPayloadWithoutEmptyValues = (data) => {
  return {
    Fields: buildFieldsPayloadWithoutEmptyValues(data.fieldConfigs, data.fieldValues),
    CaptchaToken: data.turnstileToken || 'xxx',
    PrivacyAccepted: Boolean(data.privacyAccepted),
  };
};

const buildFormData = (dataPayload, images) => {
  const formData = new FormData();
  formData.append('data', JSON.stringify(dataPayload));

  if (images && typeof images === 'object') {
    Object.entries(images).forEach(([fieldCode, file]) => {
      if (file instanceof File) {
        formData.append('files', file, fieldCode);
      }
    });
  }

  return formData;
};

export const submitForm = async (formGuid, data) => {
  try {
    const dataPayload = buildDataPayloadWithoutEmptyValues(data);
    const formData = buildFormData(dataPayload, data.images);
    const endpoint = API_CONFIG.endpoints.submitForm(formGuid);
    const response = await apiClient.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: 'Failed to submit form' };
  }
};
